import { createApp } from 'vue';
import { createPinia } from 'pinia';
import 'element-plus/dist/index.css';
import App from './App.vue';
import router from './router';
import { registerDirectives } from './directives/permission';

async function bootstrap() {
  const pinia = createPinia();
  const app = createApp(App);
  app.use(pinia);
  app.use(router);
  try {
    const { useAuthStore } = await import('@/stores/auth');
    await useAuthStore().fetchMe();
  } catch (e) { console.error('[Bootstrap] fetchMe failed', e); }
  registerDirectives(app);
  app.mount('#app');
}

bootstrap().catch((err) => console.error('[Bootstrap] fatal', err));